module.exports = __webpack_public_path__ + "static/media/homeBG.1f03aa71.svg";